import { combineReducers, configureStore } from '@reduxjs/toolkit'
import userSlice from '@Stores/user'
import scanRecordSlice from '@Stores/scanRecord'
import googleSettingSlice  from '@Stores/googleSetting'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import thunk from 'redux-thunk'

const persistConfig = {
  key: 'funcode_assets',
  storage,
}

const rootReducer = combineReducers({
  user: userSlice,
  scanRecord:scanRecordSlice,
  googleSetting:googleSettingSlice,
})

const persistedReducer = persistReducer(
  persistConfig, 
  rootReducer
)

export const store =  configureStore({
  reducer: persistedReducer,
  middleware: [thunk]
})

export const persistor = persistStore(store)

// 註冊一個回調函數，每次狀態變化時打印 Redux 狀態
// store.subscribe(() => {
//   console.log("Redux 全部狀態:", store.getState());
// });
